export function queryAll(selector, scope) {
    if (scope === void 0) { scope = document; }
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
}
